import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { httpWithAuth } from '~/clients';
import { CREDIT_STATUS } from '~/constants/endpoints';
import { useIsLoggedIn } from '~/context/common/UserContext';
import FinanceContext from '~/context/srp/FinanceContext';
import { CreditStatus, FinancingPolicy } from '~/contracts/srp';
import { generateErrorLogger } from '~/utilities/loggers';

export type CreditStatusResponse = Partial<{
  creditApplicationExpirationUtc: string;
  creditStatus: CreditStatus;
  financingPolicy: FinancingPolicy;
}>;

export default function useGetCreditStatus() {
  const isLoggedIn = useIsLoggedIn();
  const {
    creditStatus: { setData, setError, setLoaded }
  } = useContext(FinanceContext);

  useEffectWithController(
    controller => {
      if (!isLoggedIn) {
        setLoaded();

        return;
      }

      httpWithAuth
        .get<CreditStatusResponse>(CREDIT_STATUS, {
          headers: { 'X-Cvna-Finx-Clientsource': 'srp' },
          signal: controller.signal
        })
        .then(res => {
          setData(res.data || {});
        })
        .catch(
          generateErrorLogger(
            'Credit Status',
            {},
            { callback: setError, controller }
          )
        );
    },
    [isLoggedIn, setData, setError, setLoaded]
  );
}
